<script>
import { Pie } from 'vue-chartjs'

export default {
    extends: Pie,
    props: ['height'],
    data() {
        return {
            names: [],
            counts: [],
            data: '',
            colors: [],
            total: 0,
            title:'',
         
        }
    },
    methods: {
        getData() {
            axios.get('/api/dashboard?node=product_count', {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.data = response.data.data;
                    if (this.data) {
                        this.data.forEach(element => {
                            ;
                            this.names.push(element.name);
                            this.counts.push(element.total);
                            this.total += element.total;
                            for (let i = 0; i < this.data.length; i++) {
                                this.colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
                            }
                        });
                         this.title = 'Model Distribution (Total:' + this.total + ')';
                        this.renderChart({

                                labels: this.names,
                                datasets: [{
                                    label: 'Models',
                                    backgroundColor: this.colors,
                                    data: this.counts
                                }]
                            }, {
                                title: {
                                    display: true,
                                    text: this.title,
                                    fontSize: 16,
                                },
                                responsive: true,
                                maintainAspectRatio: false
                            }

                        );

                    } else {
                        console.log('NO DATA');
                    }
                }).catch(error => {

                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);

                })

        },
        getTotal() {

        },

    },

    mounted() {
        this.getData();
    }
}
</script>
